import { useId } from "react";
import { useTheme } from "@catchoftheday/theme";
export { UIDReset } from "react-uid";
export var useUID = function useUID() {
  var _useTheme = useTheme(),
      appName = _useTheme.appName;

  var id = useId();
  return "".concat(appName, "-").concat(id);
};